import amplifyTheme from './amplifyTheme';
import muiTheme from './muiTheme';
import authStyle from './authenticator.css';

export { amplifyTheme, muiTheme, authStyle };
